import { offlineDB } from './db'
import { v4 as uuidv4 } from 'uuid'

const MAX_RETRIES = 5

export async function enqueueAction(type, payload, { dependsOnClientRef = null } = {}) {
    const clientRef = payload.clientRef || uuidv4()
    const localId = await offlineDB.syncQueue.add({
        type,
        payload: { ...payload, clientRef },
        status: 'pending',
        clientRef,
        dependsOnClientRef, 
        retryCount: 0,
        created_at: new Date().toISOString(),
    })
    return { localId, clientRef }
}

export async function getPendingActions() {
    return offlineDB.syncQueue.where('status').equals('pending').sortBy('created_at')
}

export async function markSynced(localId) {
    await offlineDB.syncQueue.delete(localId)
}

export async function markFailed(localId, errorMsg) {
    const action = await offlineDB.syncQueue.get(localId)
    const retryCount = (action?.retryCount || 0) + 1

    await offlineDB.syncQueue.update(localId, {
        status: retryCount >= MAX_RETRIES ? 'error' : 'pending',
        error: errorMsg,
        retryCount,
    })
}

export async function setIdMapping(localKey, realId) {
    await offlineDB.idMap.put({ localKey, realId })
}

export async function resolveId(localKeyOrRealId) {
    if (!String(localKeyOrRealId).startsWith('local_')) return localKeyOrRealId
    const mapped = await offlineDB.idMap.get(localKeyOrRealId)
    return mapped ? mapped.realId : null // null means "not synced yet"
}

export async function claimAction(localId) {
    const updated = await offlineDB.syncQueue
        .where('localId').equals(localId)
        .and(a => a.status === 'pending')
        .modify({ status: 'processing' })
    return updated > 0
}